import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, EXPENSE_TAB, TOKEN_TYPE } from '../../../constants/constants';
import { REACT_ROUTES } from '../../../constants/react_routes';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';
import history from '../../../services/history';

export const EXPENSE_ACTION_TYPES = {
	GET_EXPENSES_SUCCESS: 'GET_EXPENSES_SUCCESS',
    POST_EXPENSE_SUCCESS: 'POST_EXPENSE_SUCCESS',
    PUT_EXPENSE_SUCCESS: 'PUT_EXPENSE_SUCCESS',
    DELETE_WORKER_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_EXPENSES_PAGINATION: 'UPDATE_EXPENSES_PAGINATION'
};

const EXPENSES_URL = `${ENTRYPOINT}${API_ROUTES.EXPENSES}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

export const getExpenses = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_EXPENSES_URL = `${EXPENSES_URL}${params}`;
        const response = await getData(GET_EXPENSES_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: EXPENSE_ACTION_TYPES.GET_EXPENSES_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: EXPENSE_ACTION_TYPES.UPDATE_EXPENSES_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getExpense = async (uuid) => {
    const GET_EXPENSE_URL = `${EXPENSES_URL}/${uuid}`;
    return await getData(GET_EXPENSE_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
}

export const postExpense = (data) => {
    console.log(data)
    return async (dispatch) => {
        const response = await postData(EXPENSES_URL, data);
        dispatch({ type: EXPENSE_ACTION_TYPES.POST_EXPENSE_SUCCESS, payload: response });
        return history.push(REACT_ROUTES.EXPENSE_TABS, { selectedTab: EXPENSE_TAB });
    }
}

export const putExpense = (uuid, data) => {
    return async (dispatch) => {
        const PUT_WORKERS_URL = `${EXPENSES_URL}/${uuid}`;
        const response = await putData(PUT_WORKERS_URL, data);
        dispatch({ type: EXPENSE_ACTION_TYPES.PUT_EXPENSE_SUCCESS, payload: response });
        history.push(REACT_ROUTES.EXPENSE_TABS, { selectedTab: EXPENSE_TAB });
    }
}

export const deleteExpense = (uuid) => (
    async () => {
        const DELETE_EXPENSE_URL = `${EXPENSES_URL}/${uuid}`;
        await deleteData(DELETE_EXPENSE_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updateExpensesPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: EXPENSE_ACTION_TYPES.UPDATE_EXPENSES_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getExpenses({ page, rowsPerPage, filters }));
    }
}

